"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var header_html_1 = __importDefault(require("./header.html"));
require("./header.less");
(function (module) {
    'use strict';
    var IS_DASHBOARD_2_ENABLED_QUERY_PARAM = 'isDashboards2=true';
    EEHeaderController.$inject = [
        '$filter',
        '$window',
        'prActiveReport',
        'rsEnvironment',
        'prEventService'
    ];
    function EEHeaderController($filter, $window, activeReport, env, eventService) {
        var _a;
        var $ctrl = this;
        eventService.on('reportRenamed', function (event, reportName) {
            $ctrl.report = reportName;
        });
        var dashboard = env.get('dashboard') || activeReport.getMetadata('dashboard');
        var settings = $filter('translate')('SETTINGS');
        var report = activeReport.getDescription();
        var queryParams = (_a = $window.location.search) !== null && _a !== void 0 ? _a : '';
        var useDashboard2Link = queryParams.includes(IS_DASHBOARD_2_ENABLED_QUERY_PARAM);
        var dashboardLink;
        var settingsLink;
        if (useDashboard2Link) {
            dashboardLink = $window.location.origin + "/reporting-dashboard/web/" + dashboard.containerId;
            settingsLink = $window.location.origin + "/reporting-dashboard/web/" + dashboard.containerId + "/settings";
        }
        else {
            dashboardLink = $window.location.origin + "/reporting-dashboard/#/dashboard/" + dashboard.containerId;
            settingsLink = $window.location.origin + "/reporting-dashboard/legacy/#/administration/" + dashboard.containerId;
        }
        angular.extend($ctrl, {
            dashboard: dashboard.name,
            settings: settings,
            report: report,
            dashboardLink: dashboardLink,
            settingsLink: settingsLink
        });
    }
    module.component('prEeHeader', {
        templateUrl: header_html_1.default,
        controller: EEHeaderController,
    });
}(angular.module('qualtrics.pr')));
